import * as types from '../../../constants/ActionTypes';
import service from '../../../service/';

export const setAcceptedSoftCheck = acceptedSoftCheck => ({
    type: types.SET_SOFT_CHECK_ACCEPTED_SOFT_CHECK,
    acceptedSoftCheck,
});

export const setAcceptedIncomeCheck = acceptedIncomeCheck => ({
    type: types.SET_SOFT_CHECK_ACCEPTED_INCOME_CHECK,
    acceptedIncomeCheck,
});

export const requestSoftCheck = params => ({
    type: types.GET_DIP,
    payload: service.softCheck(params),
});

export const setSoftCheckError = error => ({
    type: types.GET_DIP_ERROR,
    error,
});

export const setDip = data => ({
    type: types.SET_DIP,
    data,
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/SoftCheck/softCheckActions.js